interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'Article' | 'FAQPage' | 'WebPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const baseSchemas: Record<string, unknown> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '黑料社区',
      url: 'https://heiliaoshequ.com',
      logo: 'https://heiliaoshequ.com/logo.png',
      description: '黑料社区是专注于独家爆料、真实内幕揭秘的聚合平台。海量用户实名分享亲历黑料，覆盖娱乐、商业、职场等多领域。',
      foundingDate: '2020-01-01',
      email: 'tips@heiliaoshequ.com',
      telephone: '+86-400-888-6666',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CN',
        addressLocality: '北京市',
        addressRegion: '朝阳区',
        streetAddress: '建国路88号',
      },
      sameAs: [
        'https://weibo.com/heiliaoshequ',
        'https://weixin.qq.com/heiliaoshequ',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '黑料社区',
      url: 'https://heiliaoshequ.com',
      description: '黑料社区是专注于独家爆料、真实内幕揭秘的聚合平台。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://heiliaoshequ.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      publisher: {
        '@type': 'Organization',
        name: '黑料社区',
        logo: {
          '@type': 'ImageObject',
          url: 'https://heiliaoshequ.com/logo.png',
        },
      },
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = { ...(baseSchemas[type] as Record<string, unknown>), ...data };

  return (
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  );
}